import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';
import { orderSectionsDrawerSlice, OrderSectionsDrawerDispatchParams, OrderSectionsDrawerState } from '@REDUCERS';

function createOrderSectionsDrawerHook() {
    return function useOrderSectionsDrawer(equalityFn?: EqualityFn<OrderSectionsDrawerState>) {
        const state = useAppSelector((store) => store.orderSectionsDrawer, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: OrderSectionsDrawerDispatchParams) => dispatch(orderSectionsDrawerSlice.actions.open(params)),
            close: () => dispatch(orderSectionsDrawerSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createOrderSectionsDrawerHook();
